var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "lp-fade" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            staticClass: "lp-overlay",
            on: {
              click: function ($event) {
                if ($event.target !== $event.currentTarget) return null
                return _vm.close.apply(null, arguments)
              },
            },
          },
          [
            _c("div", { staticClass: "lp-popup" }, [
              _c("img", {
                staticClass: "lp-close",
                attrs: { src: require("./closure.png"), alt: "" },
                on: { click: _vm.close },
              }),
              _c("div", { staticClass: "lp-content" }, [_vm._t("default")], 2),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }